module.exports = __webpack_public_path__ + "img/newsTrueSign.3e87b092.jpg";